module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/ko_5-e4f15deab0771077b986cc9976eaf1dc.jpg";